// Store utility to avoid circular dependencies
let store;

export function setStore(storeInstance) {
  store = storeInstance;
}

export function getStore() {
  return store;
}
